<odl-tab-list alignment="center">
  @if (!isFixedLayout()) {
    <odl-tab panel="text-settings">{{ 'SETTINGS.TEXT' | translate }}</odl-tab>
    <odl-tab-panel name="text-settings">
      <nr-text-settings></nr-text-settings>
    </odl-tab-panel>
  }

  @if (fullSettingsEnabled() || canUseTwoColumns() || isFixedLayout()) {
    <odl-tab panel="page-settings">{{ 'SETTINGS.PAGE' | translate }}</odl-tab>
    <odl-tab-panel name="page-settings">
      <nr-page-settings></nr-page-settings>
    </odl-tab-panel>
  }
</odl-tab-list>
